import { ResolveFn } from '@angular/router';
import {MailInviate} from "@models/MailInviate.model";
import {inject} from "@angular/core";
import {APIService} from "@shared/api.service";

export const mailInviateResolver: ResolveFn<MailInviate> = (route, state) => {
  const filter: any = {
    year: '',
    month: '',
    customer_id: [],
    category_id: [],
    page: 1,
    page_size: 10
  }

  const QP = route.queryParams;
  Object.keys(filter).forEach((key: string) => {
    if(QP[key]) {
      if(Array.isArray(filter[key]) &&  !Array.isArray(QP[key])) {
        filter[key] = [QP[key]];
      } else {
        filter[key] = QP[key];
      }
    }
  });
  const apiService = inject(APIService);
  return apiService.get('customerinfodigests',null,filter);
};
